import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightDate',
  standalone: false,
})
export class FlightDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor(@Inject(LOCALE_ID) locale: string) {
    this.datePipe = new DatePipe(locale);
  }

  transform(
    timestamp: number | string | null | undefined,
    format: string,
    offsetDate?: string | null,
  ): string | null {
    const value = timestamp ?? offsetDate;
    if (!value) {
      return null;
    }

    const timezone = offsetDate ? this.getTimezone(offsetDate) : undefined;
    return this.datePipe.transform(value, format, timezone);
  }

  private getTimezone(value: string): string | undefined {
    const match = value.match(/(Z|[+-]\d{2}:?\d{2})$/);
    if (!match) {
      return undefined;
    }

    if (match[1] === 'Z') {
      return 'UTC';
    }

    return match[1].replace(':', '');
  }
}
